import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './detail.css';
import Sidebar from '../../components/SideBar/Sidebar.js';
import contestIcon from '../../assets/events-emoji-icon.svg';
import { hideLoading, showLoading } from '../../store/loading-reducer';
import PropTypes from 'prop-types';
import { shopMonitorSliderTime } from '../../helpers/enums';
import { getContestList } from '../../store/contest/actions';
import { formatDate } from '../../helpers/formatterHelper'
import DynamicHTMLRenderer from '../../helpers/dynamicHTMLRenderer'

export default function ShopContest({ handleloadinTiming }) {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.loading);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const contestFilter = { query: '', sort: 6 };
    const contestWrapRef = useRef(null);
    const { contestAllList } = useSelector(state => state.contest);

    useEffect(() => {
        document.title = 'Contest | CWP Team Connect';
        dispatch(showLoading());
        handleloadinTiming(shopMonitorSliderTime.LeadingTime);
    }, []);

    useEffect(() => {
        dispatch(getContestList(contestFilter)).unwrap().then(() => {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
            setIsDataLoaded(true);
        });
    }, [dispatch]);

    useEffect(() => {
        if (isLoading && isDataLoaded) {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
        }
    }, [isLoading, isDataLoaded]);

    useEffect(() => {
        if (contestWrapRef.current) {
            const items = contestWrapRef.current.querySelectorAll('.contest-listing-item');
            if (items.length > 3) {
                contestWrapRef.current.classList.add('many-contests');
            } else {
                contestWrapRef.current.classList.remove('many-contests');
            }
        }
    }, []);

    return (
        <div className="monitors-inner">
            <div className="monitors-item contest-info-item">
                <div className="monitors-header-wrap">
                    <p className="monitors-header-title">Contests</p>
                    <span className="monitors-header-icon"><img src={contestIcon} alt="Contest Icon" /></span>
                </div>
                <div className="monitors-item-event-wrap contest-item-column-wrap">
                    <div className="contest-listing-wrap" ref={contestWrapRef}>
                        {contestAllList?.length > 0 &&
                            contestAllList.slice(0, 8).map((item, index) => {

                                switch (item?.contestTypeId) {
                                    case 1:
                                        return (
                                            <a className="contest-listing-item" key={item?.baseId || index} >
                                                <span className="contest-top-info-wrap">
                                                    <span className="contest-title">{item?.title}</span>
                                                </span>
                                                <span className="contest-information-wrap">
                                                    <span className="contest-info-wrap">
                                                        <span className="contest-date"> Enter by {item?.createdDate && formatDate(item.createdDate, "MMM dd")} </span>
                                                    </span>
                                                </span>
                                            </a>
                                        );
                                    case 2:
                                        return (
                                            <a className="contest-listing-item img-container-wrap" key={item?.baseId || index} >
                                                <span className="contest-top-info-wrap">
                                                    <span className="contest-title">{item?.title}</span>
                                                </span>
                                                <span className="contest-information-wrap">
                                                    <span className="contest-information-inner">
                                                        <img className="contest-info-img" src={item?.media?.previewsrc} alt="Contest image one" />
                                                    </span>
                                                    <span className="contest-info-wrap">
                                                        <span className="contest-date"></span>
                                                    </span>
                                                </span>
                                            </a>
                                        );
                                    case 3:
                                        return (
                                            <a className="contest-listing-item img-container-wrap" key={item?.baseId || index} >
                                                <span className="contest-top-info-wrap">
                                                    <span className="contest-title">{item?.title}</span>
                                                </span>
                                                <span className="contest-information-wrap">
                                                    <span className="contest-information-inner">
                                                        <span className="contest-winner-title">{item?.subTitle}</span>
                                                    </span>
                                                    <span className="contest-info-wrap">
                                                        <span className="contest-date">{item?.content && DynamicHTMLRenderer(item?.content)}</span>
                                                    </span>
                                                </span>
                                            </a>
                                        );
                                    default:
                                        return null;
                                }
                            })
                        }
                    </div>
                </div>
            </div>
            <Sidebar pageType={"contest"} />
        </div>
    );
}

ShopContest.propTypes = {
    handleloadinTiming: PropTypes.func
};   